import { PayloadAction } from '@reduxjs/toolkit';
import { GetProjectOptions, ProjectsReducerCreator } from '../types';

const setGetProjectListForSeriesOptionsReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Partial<GetProjectOptions>>) => {
    if (state.projectsLoading) return state;

    state.getProjectsListForSeriesOptions = {
      ...state.getProjectsListForSeriesOptions,
      ...action.payload,
    };
  });
};

export default setGetProjectListForSeriesOptionsReducer;
